import React from 'react';
import { useEventParticipantNotifications } from '../../../data/hooks/notifications/useEventParticipantNotifications';
import { useMarkNotificationsRead } from '../../../data/hooks/notifications/useMarkNotificationsRead';
import { useActiveParticipantsFilter } from '../../../data/hooks/participant/useActiveParticipantsFilter';
import { useRecommendedParticipantsFilter } from '../../../data/hooks/participant/useRecommendedParticipantsFilter';
import WaitWhileBusy from '../../WaitWhileBusy';
import Screen from '../Screen';
import styles from './EventParticipants.module.scss';
import EventParticipantsHeader from './EventParticipantsHeader/EventParticipantsHeader';
import { isSuggestedParticipantsTabSelected } from './EventParticipantsHeader/ParticipantsTabs/SuggestedParticipants/isSuggestedParticipantsTabSelected';
import FilteredParticipantsList from './lists/FilteredParticipantsList';
import SuggestedParticipantsList from './lists/SuggestedParticipantsList/SuggestedParticipantsList';

const APPLIED_RECOMMENDED_FILTER = {};

const unreadNotificationsFilter = (notif) => !notif.read;

const EventParticipants = (props) => {
    const { eventId } = props,
        notifications = useEventParticipantNotifications(eventId, unreadNotificationsFilter),
        filterParams = useActiveParticipantsFilter(eventId),
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        showSuggestedParticipantsList = isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams);

    // NOTE: do not useEffect to open filter screen because it breaks navigation

    // mark notifications as read
    useMarkNotificationsRead(notifications);

    const header = <EventParticipantsHeader eventId={eventId} filterParams={filterParams} />;

    let content;
    if (showSuggestedParticipantsList) {
        content = <SuggestedParticipantsList eventId={eventId} filterParams={suggestedFilterParams} />;
    } else {
        content = <FilteredParticipantsList className={styles.list} eventId={eventId} />;
    }

    return <Screen header={header}>{content}</Screen>;
};

export default (props) => (
    <WaitWhileBusy>
        <EventParticipants {...props.match.params} />
    </WaitWhileBusy>
);
